import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { IndividualGoalType } from "./IndividualGoal";
import { StudentCardProps2 } from "./IndividualStudentCard";
import '../styles/DeleteProgressesDialog.css'
import closeIcon from '../images/close-icon.svg'
import redWarning from '../images/red-warning.svg'
import axios from "axios";
import LinearProgressBar from "./LinearProgressBar";
import SnackbarAlert from "./SnackbarAlert";

interface DeleteProgressesDialogProps {
    goalId: number
    goalList: IndividualGoalType[]
    studentList: StudentCardProps2[]
    setStudentList: any;
    handleClickClose: () => void
    isScholarship: boolean;
}

export default function DeleteProgressesDialog({ goalId, goalList, studentList, setStudentList, handleClickClose, isScholarship }: DeleteProgressesDialogProps) {

    const [cookies] = useCookies(['user'])
    const goal = goalList?.find(goal => goal.id === goalId)
    const goalName = goal?.goal || goal?.name
    const [confirmInput, setConfirmInput] = useState<string>('')
    const [progressIdList, setProgressIdList] = useState<number[]>([])
    const [loading, setLoading] = useState(false)

    const [snackbarMessage, setSnackbarMessage] = useState<null | {
        message: string,
        severity?: 'success' | 'info' | 'warning' | 'error',
        autoHideDuration?: number | null
    }>(null)

    useEffect(() => {
        if (studentList) {
            setStudentList((prev: StudentCardProps2[]) => {
                return [...prev].sort((a, b) => {
                    return (a.id).localeCompare(b.id)
                })
            })
            if (isScholarship) {
                setProgressIdList(studentList.map(student => student.scholarshipProgressId!))
            } else {
                setProgressIdList(studentList.map(student => student.individualProgressId!))
            }
        }
    }, [])

    const fetchURL = isScholarship ? `/ScholarshipProgresses/delete` : `/IndividualProgresses/delete`

    const handleDeleteProgress = () => {
        if (progressIdList.length > 0 && confirmInput === "delete") {
            setLoading(true)
            setSnackbarMessage(null)
            axios.post(fetchURL, progressIdList, {
                headers: {
                    'Authorization': `Bearer ${cookies?.user?.token}`
                },
                withCredentials: true
            }).then(res => {
                
                setSnackbarMessage({
                    message: 'Progresses deleted successfully',
                    severity: 'success',
                    autoHideDuration: 1500
                })
                setTimeout(() => {
                    setLoading(false)
                    handleClickClose()
                }, 2000)
            }).catch(err => {
                
                setSnackbarMessage({
                    message: 'Delete progresses failed! Please try again later.',
                    severity: 'error',
                    autoHideDuration: 3000
                })
                setLoading(false)
            })
        }
    }

    return (
        <div className="EditDueDateDialog">
            <div className="EditDueDateDialog-dialog">
                <button className="ProgressDialog-close-button" onClick={handleClickClose}>
                    <img src={closeIcon} width={24} height={24} alt="close-icon" />
                </button>
                {
                    (loading) &&
                    <div className="ProgressDialog-linear-progress">
                        <LinearProgressBar />
                    </div>
                }
                <div className="flex gap1">
                    <img src={redWarning} width={56} height={56} alt="red-warning" />
                    <div style={{ width: '100%' }}>
                        <div className="flex-column gap-dot5">
                            <div className="DeleteProgressesDialog-header">
                                <h4 className='DeleteProgressesDialog-title'>Delete Progresses in</h4>
                                <p className='DeleteProgressesDialog-goal-name'>{goalName}</p>
                            </div>
                            <p className='DeleteProgressesDialog-content'>Are you sure  you want to permanently delete these progresses?</p>
                        </div>
                        <table className="DeleteProgressesDialog-table">
                            <thead>
                                <tr>
                                    <th scope="col">Student ID</th>
                                    <th scope="col">Student Name</th>
                                    <th scope="col">Student Status</th>
                                    <th scope="col">Progress Status</th>
                                </tr>
                            </thead>
                            <tbody style={{ color: 'black' }}>
                                {
                                    studentList.map(({ id, title, firstName, lastName, studentStatus, isCompleted }: StudentCardProps2) => {
                                        return (
                                            <tr key={id}>
                                                <td>{id}</td>
                                                <td>{title} {firstName} {lastName}</td>
                                                <td>{studentStatus}</td>
                                                <td>{isCompleted ? 'Completed' : 'Not Completed'}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                        <div className="flex gap-dot5 DeleteProgressesDialog-confirm-container">
                            <label className='DeleteProgressesDialog-content'>Type "delete" to confirm</label>
                            <input type='text' autoCorrect="off" className='DeleteProgressesDialog-confirm-input' placeholder='delete' value={confirmInput} onChange={(e) => setConfirmInput(e.target.value)} disabled={loading} />
                        </div>
                        <div className="DeleteProgressesDialog-bottom-container" >
                            <div className="ProgressDialog-actions">
                                <button className="ProgressDialog-button" onClick={handleClickClose}>Cancel</button>
                                <button className="ProgressDialog-button" onClick={handleDeleteProgress} style={{ backgroundColor: '#D30000' }} disabled={confirmInput !== "delete" || loading}>Delete</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                (snackbarMessage) &&
                <SnackbarAlert severity={snackbarMessage.severity} message={snackbarMessage.message} />
            }
        </div>
    )
}

